import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api';
import "../styles/login.css";
import logo from "../images/logo.png";
import { FaChevronLeft, FaEye, FaEyeSlash } from 'react-icons/fa';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const RegisterPage = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [firstNameen, setFirstNameen] = useState('');
    const [lastNameen, setLastNameen] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [age, setAge] = useState('');
    const [provinceId, setProvinceId] = useState('');
    const [cityId, setCityId] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [code, setCode] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(1); // 1: اطلاعات کاربر | 2: کد تایید
    
    // State های تایمر
    const [timer, setTimer] = useState(120); // ۲ دقیقه = ۱۲۰ ثانیه
    const [isTimerActive, setIsTimerActive] = useState(false);

    // Stateهای مربوط به استان و شهر
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(false);

    const navigate = useNavigate();

    // تایمر
    useEffect(() => {
        let interval = null;
        if (isTimerActive && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setIsTimerActive(false);
            setError('مدت زمان اعتبار کد به پایان رسید. دوباره درخواست کنید.');
        }
        return () => clearInterval(interval);
    }, [isTimerActive, timer]);

    // فرمت کردن زمان به دقیقه:ثانیه
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    // دریافت لیست استان‌ها در ابتدای بارگذاری
    useEffect(() => {
        const fetchProvinces = async () => {
            setLoadingLocations(true);
            try {
                const response = await api.get('/pre_student/api/v3/locations/provinces/');
                setProvinces(response.data);
            } catch (err) {
                console.error('خطا در دریافت استان‌ها:', err);
                setError('دریافت لیست استان‌ها با مشکل مواجه شد.');
            } finally {
                setLoadingLocations(false);
            }
        };
        fetchProvinces();
    }, []);

    const handleCodeChange = (e) => {
        const value = e.target.value;
        const englishNumber = convertPersianToEnglishNumbers(value);
        if (englishNumber === '' || /^\d+$/.test(englishNumber)) {
            setCode(englishNumber);
        }
    };

    // دریافت شهرها هنگام تغییر استان
    useEffect(() => {
        if (!provinceId) {
            setCities([]);
            setCityId('');
            return;
        }

        const fetchCities = async () => {
            setLoadingLocations(true);
            try {
                const response = await api.get(`/pre_student/api/v3/locations/cities/${provinceId}/`);
                setCities(response.data);
                setCityId('');
            } catch (err) {
                console.error('خطا در دریافت شهرها:', err);
                setError('دریافت لیست شهرها با مشکل مواجه شد.');
                setCities([]);
            } finally {
                setLoadingLocations(false);
            }
        };
        fetchCities();
    }, [provinceId]);

    // توابع کمکی
    const convertPersianToEnglishNumbers = (text) => {
        const persianToEnglish = {
            '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
            '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
        };
        return text.replace(/[۰-۹]/g, (match) => persianToEnglish[match]);
    };

    const containsPersianCharacters = (text) => {
        const persianRegex = /[\u0600-\u06FF]/;
        return persianRegex.test(text);
    };

    // توابع هندلر برای فیلدها
    const handlePhoneChange = (e) => {
        const value = e.target.value;
        setPhoneNumber(convertPersianToEnglishNumbers(value));
    };

    const handleAgeChange = (e) => {
        const value = e.target.value;
        const englishNumber = convertPersianToEnglishNumbers(value);
        if (englishNumber === '' || /^\d+$/.test(englishNumber)) {
            setAge(englishNumber);
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        if (containsPersianCharacters(value)) {
            setError('رمز عبور نباید شامل حروف فارسی باشد');
            return;
        }
        setError('');
        setPassword(value);
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        if (containsPersianCharacters(value)) {
            setError('تکرار رمز عبور نباید شامل حروف فارسی باشد');
            return;
        }
        setError('');
        setConfirmPassword(value);
    };

    // هندلر برای paste
    const handlePaste = (e, setter, converter) => {
        const pastedText = e.clipboardData.getData('text');
        if (converter) {
            e.preventDefault();
            setter(converter(pastedText));
        }
    };

    const validateForm = () => {
        if (!firstName.trim()) return "لطفا نام فرزند را وارد کنید.";
        if (!lastName.trim()) return "لطفا نام خانوادگی فرزند را وارد کنید.";
        if (!firstNameen.trim()) return "لطفا نام فرزند را به انگلیسی وارد کنید.";
        if (!lastNameen.trim()) return "لطفا نام خانوادگی فرزند را به انگلیسی وارد کنید.";
        if (!phoneNumber.trim()) return "لطفا شماره تلفن همراه والد را وارد کنید.";
        if (!/^09\d{9}$/.test(phoneNumber)) return "شماره تلفن همراه معتبر نیست.";
        if (!age.trim()) return "لطفا سن فرزند را وارد کنید.";
        if (isNaN(age) || Number(age) <= 0) return "سن فرزند معتبر نیست.";
        if (!provinceId) return "لطفا استان را انتخاب کنید.";
        if (!cityId) return "لطفا شهر را انتخاب کنید.";
        if (!birthDate.trim()) return "لطفا تاریخ تولد را وارد کنید.";
        if (!password.trim()) return "لطفا رمز عبور را وارد کنید.";
        if (password.length < 6) return "رمز عبور باید حداقل 6 کاراکتر باشد.";
        if (!confirmPassword.trim()) return "لطفا تکرار رمز عبور را وارد کنید.";
        if (password !== confirmPassword) return "رمز عبور و تکرار آن یکسان نیستند.";
        return null;
    };

    // ارسال مجدد کد
    const handleResendCode = async () => {
        setError('');
        setMessage('');
        setLoading(true);
        try {
            const response = await api.post('/pre_student/api/v3/send_otp_code/', {
                phone_number: phoneNumber,
            });
            setMessage(response.data?.message || 'کد تایید مجدداً ارسال شد.');
            setTimer(120); // ریست تایمر
            setIsTimerActive(true);
        } catch (err) {
            setError(err.response?.data?.error || 'ارسال مجدد کد با مشکل مواجه شد.');
        } finally {
            setLoading(false);
        }
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        const validationError = validateForm();
        if (validationError) {
            setError(validationError);
            return;
        }

        setLoading(true);

        try {
            const response = await api.post('/pre_student/api/v3/send_otp_code/', {
                phone_number: phoneNumber,
            });

            setMessage(response.data?.message || 'کد تایید با موفقیت ارسال شد.');
            setStep(2);
            setIsTimerActive(true); // شروع تایمر
            setTimer(120); // تنظیم تایمر به ۲ دقیقه
        } catch (err) {
            setError(err.response?.data?.error || 'ارسال کد تایید با مشکل مواجه شد.');
        } finally {
            setLoading(false);
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!code.trim()) {
            setError('لطفا کد تایید را وارد کنید.');
            return;
        }

        setLoading(true);

        try {
            const response = await api.post('/pre_student/api/v3/pre_student_register/', {
                phone_number: phoneNumber,
                code: code,
                password: password,
                first_name: firstName,
                last_name: lastName,
                first_name_en: firstNameen,
                last_name_en: lastNameen,
                province_id: Number(provinceId),
                city_id: Number(cityId),
                birth_date: birthDate,
                age: Number(age),
            });

            if (response.data?.access && response.data?.refresh) {
                localStorage.setItem('accessToken', response.data.access);
                localStorage.setItem('refreshToken', response.data.refresh);
                setMessage(response.data?.message || 'ثبت‌نام با موفقیت انجام شد');
                setIsTimerActive(false); // متوقف کردن تایمر
                navigate('/');
            } else {
                setError('مشکلی در پاسخ سرور پیش آمده است.');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'ثبت‌نام انجام نشد.');
        } finally {
            setLoading(false);
        }
    };

    const handleBackToForm = () => {
        setError('');
        setMessage('');
        setStep(1);
        setIsTimerActive(false); // متوقف کردن تایمر هنگام بازگشت
    };

    return (
        <div className='d-flex justify-content-center' style={{ alignItems: "center", height: "100vh" }}>
            <div className="login-body">
                <div className="wrapper">
                    <form onSubmit={step === 1 ? handleSendOtp : handleRegister}>
                        <div className="login_box p-lg-5 p-4">
                            <div className='logo-container d-flex justify-content-center'>
                                <img className='rounded-circle p-2' src={logo} width={60} height={60} alt="logo" />
                            </div>

                            <span className='fs-5 d-flex justify-content-center my-4'>
                                مجموعه آموزشی پایتون تیک
                            </span>

                            <span className='green d-flex justify-content-center mt-4'>
                                {step === 1 ? 'ثبت نام' : 'تایید کد'}
                            </span>

                            <span className='complete-info my-2 d-flex justify-content-center'>
                                {step === 1
                                    ? 'برای ثبت نام در پنل کاربری اطلاعات زیر را کامل کنید'
                                    : `کد تایید ارسال شده به ${phoneNumber} را وارد کنید`}
                            </span>

                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}

                            {message && (
                                <div className="alert alert-success" role="alert">
                                    {message}
                                </div>
                            )}

                            {step === 1 && (
                                <>
                                    <div className="input_box">
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            placeholder=' نام فرزند ( فارسی )'
                                        />
                                    </div>
                                    <div className="input_box">
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            placeholder=' نام خانوادگی فرزند ( فارسی )'
                                        />
                                    </div>
                                    <div className="input_box">
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={firstNameen}
                                            onChange={(e) => setFirstNameen(e.target.value)}
                                            placeholder='نام فرزند ( انگلیسی )'
                                        />
                                    </div>

                                    <div className="input_box">
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={lastNameen}
                                            onChange={(e) => setLastNameen(e.target.value)}
                                            placeholder='  نام خانوادگی فرزند (انگلیسی)'
                                        />
                                    </div>
                                    <div className="input_box">
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={phoneNumber}
                                            onChange={handlePhoneChange}
                                            placeholder='تلفن همراه والد'
                                            onPaste={(e) => {
                                                const pastedText = e.clipboardData.getData('text');
                                                e.preventDefault();
                                                setPhoneNumber(convertPersianToEnglishNumbers(pastedText));
                                            }}
                                        />
                                    </div>

                                    <div className="input_box">
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={age}
                                            onChange={handleAgeChange}
                                            placeholder='سن فرزند'
                                            onPaste={(e) => {
                                                const pastedText = e.clipboardData.getData('text');
                                                e.preventDefault();
                                                const englishNumber = convertPersianToEnglishNumbers(pastedText);
                                                if (/^\d+$/.test(englishNumber)) {
                                                    setAge(englishNumber);
                                                }
                                            }}
                                        />
                                    </div>

                                    {/* انتخاب استان */}
                                    <div className="input_box">
                                        <select
                                            className="input-field"
                                            value={provinceId}
                                            onChange={(e) => setProvinceId(e.target.value)}
                                            disabled={loadingLocations}
                                        >
                                            <option value="">استان   </option>
                                            {provinces.map((province) => (
                                                <option key={province.id} value={province.id}>
                                                    {province.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* انتخاب شهر */}
                                    <div className="input_box">
                                        <select
                                            className="input-field"
                                            value={cityId}
                                            onChange={(e) => setCityId(e.target.value)}
                                            disabled={!provinceId || loadingLocations}
                                        >
                                            <option value="">شهر   </option>
                                            {cities.map((city) => (
                                                <option key={city.id} value={city.id}>
                                                    {city.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="birth">
                                        <DatePicker
                                            calendar={persian}
                                            placeholder='تاریخ تولد'
                                            locale={persian_fa}
                                            className=""
                                            value={birthDate}
                                            onChange={(date) => setBirthDate(date?.format("YYYY-MM-DD"))}
                                            style={{
                                                width: "100%",
                                                padding: "20px 30px",
                                                borderRadius: "8px",
                                                border: "1px solid #ccc", 
                                                marginTop: "10px"
                                            }}
                                        />
                                    </div>

                                    <div className="input_box" style={{ position: "relative" }}>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="input-field"
                                            value={password}
                                            onChange={handlePasswordChange}
                                            placeholder='رمز عبور'
                                            onPaste={(e) => {
                                                const pastedText = e.clipboardData.getData('text');
                                                if (containsPersianCharacters(pastedText)) {
                                                    e.preventDefault();
                                                    setError('رمز عبور نباید شامل حروف فارسی باشد');
                                                } else {
                                                    setPassword(pastedText);
                                                }
                                            }}
                                        />
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: "absolute",
                                                left: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                                color: "#555",
                                            }}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>

                                    <div className="input_box" style={{ position: "relative" }}>
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            className="input-field"
                                            value={confirmPassword}
                                            onChange={handleConfirmPasswordChange}
                                            placeholder='تکرار رمز عبور'
                                            onPaste={(e) => {
                                                const pastedText = e.clipboardData.getData('text');
                                                if (containsPersianCharacters(pastedText)) {
                                                    e.preventDefault();
                                                    setError('تکرار رمز عبور نباید شامل حروف فارسی باشد');
                                                } else {
                                                    setConfirmPassword(pastedText);
                                                }
                                            }}
                                        />
                                        <span
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            style={{
                                                position: "absolute",
                                                left: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                                color: "#555",
                                            }}
                                        >
                                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </>
                            )}

                            {step === 2 && (
                                <>
                                    <div className="input_box">
                                        <input
                                            type="text"
                                            className="input-field"
                                            value={code}
                                            onChange={handleCodeChange}
                                            placeholder='کد تایید'
                                            onPaste={(e) => {
                                                const pastedText = e.clipboardData.getData('text');
                                                e.preventDefault();
                                                const englishNumber = convertPersianToEnglishNumbers(pastedText);
                                                if (/^\d+$/.test(englishNumber)) {
                                                    setCode(englishNumber);
                                                }
                                            }}
                                        />
                                    </div>

                                    {/* نمایش تایمر */}
                                    <div className="text-center my-2">
                                        <span className="text-muted">
                                            زمان باقی‌مانده: <strong className="" style={{color:"rgba(43, 167, 105, 1)"}}>{formatTime(timer)}</strong>
                                        </span>
                                    </div>

                                    {/* دکمه ارسال مجدد کد */}
                                    <div className="text-center mb-3">
                                        <button
                                            type="button"
                                            className="btn btn-link text-decoration-none"
                                            onClick={handleResendCode}
                                            disabled={isTimerActive || loading}
                                            style={{ fontSize: "14px" }}
                                        >
                                            {loading ? 'در حال ارسال...' : 'ارسال مجدد کد'}
                                        </button>
                                    </div>

                                    <div className="d-flex gap-2 mt-3">
                                        <button
                                            type="button"
                                            className="input-submit"
                                            onClick={handleBackToForm}
                                            style={{ background: '#6c757d' }}
                                        >
                                            بازگشت
                                        </button>

                                        <button
                                            type="submit"
                                            className="input-submit"
                                            disabled={loading}
                                        >
                                            {loading ? 'در حال ثبت نام...' : 'ثبت نام نهایی'}
                                            <FaChevronLeft className='me-2' style={{ fontSize: "11px" }} />
                                        </button>
                                    </div>
                                </>
                            )}

                            {step === 1 && (
                                <div>
                                    <div className="input_box">
                                        <button
                                            type="submit"
                                            className="input-submit"
                                            disabled={loading || loadingLocations}
                                        >
                                            {loading ? 'در حال ارسال کد...' : 'ارسال کد تایید'}
                                            <FaChevronLeft className='me-2' style={{ fontSize: "11px" }} />
                                        </button>
                                    </div>
                                    <div className="text-center mt-2 pt-2" style={{ borderTop: "1px solid #eee" }}>
                                        <span style={{ fontSize: "14px", color: "#6c757d" }}>
                                            قبلاً ثبت‌نام کرده‌اید؟{" "}
                                            <a
                                                onClick={() => navigate('/login')}
                                                style={{
                                                    color: "#28a745",
                                                    textDecoration: "none",
                                                    fontWeight: "600",
                                                    cursor: "pointer"
                                                }}
                                                onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                                                onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                                            >
                                                وارد شوید
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;